import { cn } from "@/lib/utils";

interface SkipToMainContentProps {
  targetId?: string;
  className?: string;
}

/**
 * Skip To Main Content.
 */
export function SkipToMainContent({
  targetId = "main-content",
  className,
}: Readonly<SkipToMainContentProps>) {
  return (
    <a
      href={`#${targetId}`}
      className={cn(
        "sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100]",
        "focus:rounded-md focus:bg-background focus:px-4 focus:py-2 focus:text-sm focus:font-medium",
        "focus:shadow-md focus:ring-2 focus:ring-ring",
        className
      )}
    >
      Skip to main content
    </a>
  );
}
